import {
  Tabs, TabList, TabPanels, Tab, TabPanel,
  Box,
} from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { isComparativeReportState } from '../../state/filtersContext';

export function ReportContainer({ children }) {
  const tabs = Array.isArray(children) ? children : [children];
  const isComparativeReport = useRecoilValue(isComparativeReportState);
  const [filtersHeight, setFiltersHeight] = useState(0);
  const stickyOffset = filtersHeight + 145;
  const sentinelRef = useRef(null);
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const element = document.getElementById('onf-filters-container');
    if (!element) return;

    const observer = new ResizeObserver((entries) => {
      setFiltersHeight(entries[0].contentRect.height);
    });

    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!sentinelRef.current) return;
    if (!filtersHeight) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsStuck(!entry.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: `-${stickyOffset}px 0px 0px 0px`,
      },
    );

    observer.observe(sentinelRef.current);

    return () => observer.disconnect();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersHeight]);

  return (
    <>
      <Box ref={sentinelRef} height="1px" />
      <Tabs
        variant="custom"
        defaultIndex={isComparativeReport ? tabs.length - 1 : 0}
        overflowX="clip"
      >
        <TabList
          position="sticky"
          top={stickyOffset}
          background="gray.50"
          zIndex="100"
          pt={2}
          boxShadow={isStuck ? '0 4px 8px -2px rgba(0,0,0,0.15)' : 'none'}
          transition="box-shadow 0.2s ease"
        >
          {tabs.map((tab, index) => (
            <Tab key={index}>
              {tab.props.title}
            </Tab>
          ))}
        </TabList>

        <TabPanels>
          {tabs.map((tab, index) => (
            <TabPanel key={index} px={0}>
              {tab.props.children}
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </>
  );
}
